import { useContext } from 'react';
import { DragAndDropContext } from './DragAndDrop.context.tsx';

export const useDragAndDrop = () => {
  const context = useContext(DragAndDropContext);

  if (!context) {
    throw new Error('useDragAndDrop() must be used within DragAndDropProvider');
  }

  return context;
};
